/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, FullscreenDialog, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import WarningIcon from './images/warning-icon.svg';

type ErrorViewProps = {
  headingText?: string;
  bodyText?: string;
};

const styles = {
  container: () => css`
    padding-top: var(--cds-spacing-1400);
    overflow-y: auto;

    ${breakpoints.down('sm')} {
      padding-top: var(--cds-spacing-400);
    }
  `,
  icon: () => css`
    width: 70px;
    margin-bottom: var(--cds-spacing-400);
  `,
  pageTitle: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

export const ErrorView = ({ headingText, bodyText }: ErrorViewProps) => {
  const { Content, Actions } = FullscreenDialog;
  return (
    <>
      <Content id="enrollmentDialogContent" aria-live="polite" aria-atomic="true">
        <div css={styles.container}>
          <img css={styles.icon} src={WarningIcon} alt={_t(`Warning icon`)} />
          {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
          <Typography component="h1" variant="h1semibold" css={styles.pageTitle}>
            {headingText || _t(`This page won't load`)}
          </Typography>
          <Typography2 component="p" variant="bodyPrimary">
            {bodyText || _t('There seems to be an error loading this page, please try again.')}
          </Typography2>
        </div>
      </Content>
      <Actions>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          {_t('Retry')}
        </Button>
      </Actions>
    </>
  );
};

export default ErrorView;
